export const INSTAGRAM_LINK = 'https://www.instagram.com/dragan_strukelj';
export const ASSET_IMAGES_PATH = process.env.PUBLIC_URL + '/assets/images';

// Branding: show the signature image above the wordmark. When false, the wordmark alone renders,
// centered within the same footprint (the header layout is unchanged). Site-wide default for the
// <Brand> component; overridable per instance via <Brand showSignature={…} />.
export const SHOW_BRAND_SIGNATURE = false;

// Site-level metadata for SEO (canonical URLs, Open Graph, structured data).
export const SITE_URL = 'https://draganstrukelj.com';
export const SITE_NAME = 'Dragan Strukelj';
export const SITE_DEFAULT_DESCRIPTION =
    'Contemporary painter Dragan Strukelj — ethereal, dreamlike oil paintings exploring identity, judgement, and hope.';
// Default share image (a representative work) for routes that don't supply their own.
export const SITE_OG_IMAGE = ASSET_IMAGES_PATH + '/artwork/original/red-room.webp';